//Please delete the file once backend team merge the actual data
// const header={
//    Headers:[
//       {
//          "FilterId":5,
//          "FilterName":"Account Number",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":4,
//          "FilterName":"Circuit ID",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":7,
//          "FilterName":"Circuit Status",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":1,
//          "FilterName":"Circuit Type",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":16,
//          "FilterName":"Company Code (Account)",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":13,
//          "FilterName":"Company Code (Subscription)",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":17,
//          "FilterName":"Cost Center(Account)",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":14,
//          "FilterName":"Cost Center(Subscription)",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":12,
//          "FilterName":"Currency",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":11,
//          "FilterName":"Disconnect Date",
//          "FilterType":"Date Range",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":18,
//          "FilterName":"GL Code (Account)",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":15,
//          "FilterName":"GL Code (Subscription)",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":10,
//          "FilterName":"Install Date",
//          "FilterType":"Date Range",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":19,
//          "FilterName":"Location 1",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":20,
//          "FilterName":"Location 2",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":3,
//          "FilterName":"Primary/Secondary",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":2,
//          "FilterName":"Sub Category",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":9,
//          "FilterName":"User Email Address",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":8,
//          "FilterName":"User HR ID",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       },
//       {
//          "FilterId":6,
//          "FilterName":"Vendor",
//          "FilterType":"Textbox",
//          "Page":"CircuitInventoryReport",
//          "State":true,
//          "Createdby":null,
//          "DateCreated":"0001-01-01T00:00:00",
//          "Modifiedby":null,
//          "DateModified":null,
//          "DropDownFilterOpts":null
//       }
//    ]
// }

// export default header;


const notification={
   Data:[
      {
         "Id": 1,
         "Title":"Invoice Match/Audit",
         "InvoiceNumber":"INV1234567890",
         "Status":"Completed",
         "Date":"14/11/2022"
      },
      {
         "Id": 2,
         "Title":"Invoice Match/Audit",
         "InvoiceNumber":"INV1234567890",
         "Status":"In Progress",
         "Date":"14/11/2022"
      },
      {
         "Id": 3,
         "Title":"Granite (US)",
         "Invoice":"INV1234567890",
         "Status":"In Progress",
         "Date":"14/11/2022"
      },
      {
         "Id": 4,
         "Title":"Invoice Upload",
         "Vendor":"Granite (US)",
         "Status":"In Progress",
         "Date":"14/11/2022"
      },
      {
         "Id": 5,
         "Title":"Granite (US)",
         "InvoiceNumber":"INV1234567890",
         "Status":"Failed",
         "Date":"14/11/2022"
      },
      {
         "Id": 6,
         "Title":"Invoice Upload",
         "Vendor":"Granite (US)",
         "Status":"Failed",
         "Date":"14/11/2022"
      }
   ]
}

export default notification;